// 四六级
const cetIndex = () => import('../pages/cet/cetIndex.vue');
export default [
  {
    path: '/cetIndex',
    component: cetIndex,
  },
];
